import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import EmbeddedImagePicker from "./EmbeddedImagePicker";

interface ImagePickerProps {
  open: boolean;
  onClose: () => void;
  onSelect: (imageUrl: string, imageId?: string) => void;
  getToken: () => Promise<string>;
  companyId: string;
  contentId?: string;
  selectedImage?: string;
  showAiGenerate?: boolean;
  showApplyFrame?: boolean;
  showStockImages?: boolean;
}

const ImagePicker: React.FC<ImagePickerProps> = ({
  open,
  onClose,
  onSelect,
  getToken,
  companyId,
  contentId,
  selectedImage,
  showAiGenerate = true,
  showApplyFrame = true,
  showStockImages = true,
}) => {
  const [tempSelected, setTempSelected] = useState<{
    url: string;
    id?: string;
  } | null>(null);

  const handleImageSelect = (url: string, imageId?: string) => {
    setTempSelected({ url, id: imageId });
  };

  const handleConfirmSelection = () => {
    if (tempSelected) {
      onSelect(tempSelected.url, tempSelected.id);
      setTempSelected(null);
      onClose();
    }
  };

  const handleClose = () => {
    setTempSelected(null);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: "80vh",
          maxHeight: "800px",
        },
      }}
    >
      <DialogTitle>
        Select Image
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <EmbeddedImagePicker
          onSelect={handleImageSelect}
          getToken={getToken}
          companyId={companyId}
          contentId={contentId}
          selectedImage={tempSelected?.url || selectedImage}
          height="100%"
          showAiGenerate={showAiGenerate}
          showApplyFrame={showApplyFrame}
          showStockImages={showStockImages}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleConfirmSelection}
          variant="contained"
          disabled={!tempSelected}
        >
          Select Image
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImagePicker;